import { IRoute, IUser } from '../../models';
import React, { useEffect, useState } from 'react';
import PaneHeadline from '../shared/paneHeadline';
import { faBusinessTime } from '@fortawesome/free-solid-svg-icons';
import './timeUsageReport.scss';
import { ITimeUsageReport } from '../../models/TimeUsageReport.model';
import SideFilter from '../SideFilter/SideFilter';
import moment from 'moment';
import { IFraction } from '../../models/Fraction.model';
import { ISideFilter } from '../../models/SideFilterObject.model';
import { FilterOption } from '../orderOverview/OrderOverview';
import TimeUsageReportGrid from './TimeUsageReportGrid';
import { filterByDropdowns } from '../orderCalendar/filters';
import { Spinner2 } from '../shared/spinner2';
import { locale } from '../../common/localization/localizationService';
import TimeUsageReportCharts from './TimeUsageReportCharts';

export interface ITimeUsageReportProps {
  impersonatedUser: any;
  authentication: IUser;
  isLoading: boolean;
  timeUsageReportList: Array<ITimeUsageReport>;
  loadTimeUsageReports: (
    from: Date | string,
    to: Date | string,
    ignoreCache: boolean,
  ) => void;
  orderActions: any;
  loadRoutes: () => void;
  allFractions: Array<IFraction>;
  routes: Array<IRoute>;
  timeUsageReportFilter: ISideFilter;
  setFilter: (filter: ISideFilter) => void;
  isChartsVisible: boolean;
  setChartVisibility: (isVisible: boolean) => void;
}

export default function TimeUsageReportPage(
  props: ITimeUsageReportProps,
): JSX.Element {
  const [fractionOptions, setFractionOptions] = useState<Array<FilterOption>>(
    [],
  );
  const [routes, setRoutes] = useState<Array<FilterOption>>([]);

  const [timeUsageReportList, setTimeUsageReportList] = useState<Array<any>>(
    props.timeUsageReportList,
  );

  useEffect(() => {
    const filterObject = props.timeUsageReportFilter;
    const formattedFromDate = new Date(filterObject.fromDate)
      .toISOString()
      .split('T')[0]
      .replace(/-/g, '');
    const formattedToDate = new Date(filterObject.toDate)
      .toISOString()
      .split('T')[0]
      .replace(/-/g, '');
    if (moment(formattedFromDate).unix() < moment(formattedToDate).unix()) {
      props.orderActions.getAllFractions();
      props.loadRoutes();
    }
  }, [props.orderActions]);

  useEffect(() => {
    if (props.timeUsageReportList) {
      const filterObject = props.timeUsageReportFilter;
      const filteredOrders = filterByDropdowns(
        props.timeUsageReportList,
        filterObject,
      );
      setTimeUsageReportList(filteredOrders);
    }
  }, [props.timeUsageReportList]);

  useEffect(() => {
    const options = props.routes.map((route) => ({
      value: route.name,
      label: route.name,
    }));
    setRoutes(options);
  }, [props.routes]);

  useEffect(() => {
    const options = props.allFractions.map((fraction) => ({
      value: fraction.fractionId,
      label: fraction.name,
    }));
    setFractionOptions(options);
  }, [props.allFractions]);

  useEffect(() => {
    const filterObject = props.timeUsageReportFilter;
    const filteredOrders = filterByDropdowns(
      props.timeUsageReportList,
      filterObject,
    );
    setTimeUsageReportList(filteredOrders);
  }, [
    props.timeUsageReportFilter.fractionIds,
    props.timeUsageReportFilter.routeIds,
  ]);

  const filterByInterval = (from: string, to: string): void => {
    props.loadTimeUsageReports(from, to, true);
  };

  return (
    <>
      <div className="time-usage-report-tab">
        <div className="time-usage-report-header-row row">
          <PaneHeadline
            titleText={locale.timeUsageReport._header}
            titleIcon={faBusinessTime}
            className="time-usage-report-header-element"
          />
          <div className="time-usage-report-action-wrapper">
            {!props.isChartsVisible && (
              <button
                className="btn btn-outline-dark mr-2 open-modal-button"
                onClick={() => props.setChartVisibility(true)}
              >
                {locale.timeUsageReport._diagramView}
              </button>
            )}
            {props.isChartsVisible && (
              <button
                className="btn btn-outline-dark mr-2 open-modal-button"
                onClick={() => props.setChartVisibility(false)}
              >
                {locale.timeUsageReport._tableView}
              </button>
            )}
          </div>
        </div>
        <Spinner2 show={props.isLoading} />
        <div className="time-usage-report-grid-content">
          {!props.isChartsVisible && (
            <TimeUsageReportGrid
              data={timeUsageReportList}
              fractions={props.allFractions}
            />
          )}
          {props.isChartsVisible && (
            <TimeUsageReportCharts data={timeUsageReportList} />
          )}
          <div className={`time-usage-report-filter open`}>
            <SideFilter
              allFractions={props.allFractions}
              contractors={null}
              fractionOptions={fractionOptions}
              orderActions={props.orderActions}
              filter={props.timeUsageReportFilter}
              routes={routes}
              statuses={null}
              filterAction={props.setFilter}
              filterByInerval={filterByInterval}
            />
          </div>
        </div>
      </div>
    </>
  );
}
